import { AbstractSearchCriteria } from './abstract-search-criteria';

export class CitySearchCriteria extends AbstractSearchCriteria {
    codeOrName: string = '';
    code: string = '';
    name: string = '';
    countryCode: string = '';
    stateCode: string = '';
}
